/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {useDispatch} from 'react-redux'
import {Languages} from '../../../partials/layout/header-menus/Languages'
import * as auth from "../../../../app/modules/auth/redux/AuthRedux";

const API_URL = process.env.REACT_APP_API_URL
export const DRUPAL_URL_LOGOUT = `${API_URL}/logout/openid`


const AsideDefault: FC = () => {

  const intl = useIntl()
  const {config, classes} = useLayout()
  const {aside} = config
  const dispatch = useDispatch()
  const logout = () => {
	  
	  //REDIRECT DRUPAL CONNEXION
	  var redirect = window.location.protocol + '//' + window.location.host + '/auth/login';
	  window.location.href = DRUPAL_URL_LOGOUT + "?redirect=" + redirect
  
    //dispatch(auth.actions.logout())
  }
  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className='h-25px logo'
              src={toAbsoluteUrl('/media/custom/logo.svg')}
            />
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className='h-35px logo'
              src={toAbsoluteUrl('/media/custom/logo.svg')}
            />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}
      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto pt-5 pb-15 px-5' id='kt_aside_footer'>
        <Languages />
        <a
            target='_blank'
            className='btn btn-custom btn-sm btn-secondary w-100'
            onClick={logout}
        >
          <span className='btn-label'>{intl.formatMessage({id: 'AUTH.LOGOUT.BUTTON'})}</span>
          <span className='svg-icon btn-icon svg-icon-1'>
            <KTSVG path='/media/icons/duotune/arrows/arr043.svg' />
          </span>
        </a>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
